import Router from 'next/router'

import { removeQueryParam } from 'utility-tools/module/requests'
import { appConfigContext } from 'nexchange-service/appServiceConfig'
import {getReferralToken, setReferralToken} from "./auth";

const removeRefParam = () => {
    const urlWithoutRef = removeQueryParam('ref', window.location.href)
    Router.replace(urlWithoutRef, null, { shallow: true })
}

const storeReferralTokenFromQuery = query => {
    const { ref: referralTokenParam } = query
    const currentReferralToken = getReferralToken()

    const isReferralCodeChanged =
        referralTokenParam ||
        (!currentReferralToken && appConfigContext.getAppConfig().REFERRAL_CODE)

    if (isReferralCodeChanged) {
        const newReferralToken = referralTokenParam || appConfigContext.getAppConfig().REFERRAL_CODE
        setReferralToken(newReferralToken)
    }
}

export { storeReferralTokenFromQuery }
